<template>
  <div>
    <section class="overlay overlay-text" v-if="errored">
      <p class="overlay-text">申し訳ありませんが、<br />現時点ではこの情報を取得できません。<br />しばらくしてからもう一度お試しください</p>
    </section>

    <section v-else>
      <div class="overlay" v-if="loading">
        <p class="overlay-text loading-text">Loading...</p>
        <div class="loading-spacer">
          <vue-loading type="spiningDubbles" color="#FFF" :size="{ width: '100px', height: '100px' }"></vue-loading>
        </div>
      </div>
      <Header />
      <div class="date">
        <span class="parenthesis" @click="previousDay">＜</span><span class="day">{{ date }}</span
        ><span v-show="isNextDay" class="parenthesis" @click="nextDay">＞</span>
      </div>
      <div class="nominal">
        <img class="selected-foodstuff" src="@/assets/meal_history/アセット 1@2x.png" v-show="selected" width="902" height="220" loding="lazy" />
        <img class="nomal-foodstuff" src="@/assets/meal_history/アセット 3@2x.png" v-show="!selected" @click="showRecordsMain" width="561" height="142" loding="lazy" />
        <img class="selected-water" src="@/assets/meal_history/アセット 38@2x.png" v-show="!selected" width="902" height="220" loding="lazy" />
        <img class="nomal-water" src="@/assets/meal_history/アセット 37@2x.png" v-show="selected" @click="showWaterIntake" width="337" height="142" loding="lazy" />
      </div>

      <!-- 主食・副食タグを表示する -->
      <div class="meal-records-main" v-if="selected">
        <div class="compartment"></div>
        <div :id="index" class="meals-list" v-for="(meals, index) in mealslist" :key="meals.id" v-bind:class="['foods-' + index]">
          <img class="meal-img" v-bind:src="meals.image" @touchstart.prevent="ingestedFood(index)" key="username"/>
          <div class="meal-right">
            <img v-bind:src="meals.right" v-bind:style="{ display: meals.display}" v-if="!isActive"/>
            <img v-bind:src="meals.editRight" v-bind:style="{ display: meals.display}" @touchstart.prevent="ingestedFood(index)" v-if="isActive"/>
          </div>
        </div>
      </div>

      <!-- 水分量タグを表示する -->
      <div class="water-intake-main" v-show="!selected">
        <div class="water-amount">
          <img v-show="!isWaterActive" v-bind:src="teaCup.img" class="tea-drink" :id="index" v-for="(teaCup, index) in teaCups" @click="pushedTeaDrink(index + 1)" />
          <img v-show="isWaterActive" v-bind:src="teaCup.editImg" class="tea-drink" :id="index" v-for="(teaCup, index) in teaCups" @click="pushedTeaDrink(index + 1)" />
          <img class="hand-tea-drink" src="@/assets/meal_entry/アセット 29@2x.png" width="335" height="457" loading="lazy" />
        </div>
        <div>
          <p class="Intake-target-text">※１日の摂取目標は7杯(約1000ml)</p>
        </div>
      </div>

      <div class="foods-intake">
        <img v-show="selected" src="@/assets/meal_history/アセット 30@2x.png" width="1177" height="844" loding="lazy" />
        <img v-show="!selected" src="@/assets/meal_history/アセット 31@2x.png" width="1177" height="844" loding="lazy" />
        <div v-show="selected">
          <p v-show="!mealslist[0].ingested"><img class="facial-expression" src="@/assets/home/アセット 25@2x.png" width="340" height="341" loding="lazy" /></p>
          <p v-show="mealslist[0].ingested"><img class="facial-expression" src="@/assets/home/アセット 23@2x.png" width="340" height="341" loding="lazy" /></p>
          <p class="score">{{ targetFoodsIngested.score }}</p>
        </div>
        <div v-show="!selected">
          <p class="ingested-water-cup">{{ ingestedWater }}</p>
          <p class="ingested-water-amount">{{ targetFoodsIngested.water }}</p>
        </div>
      </div>

      <div>
        <div class="img-style">
          <img class="editing-meal-records history-float-right" src="@/assets/meal_history/アセット 17@2x.png" v-show="selected" @click="editingMealRecords" />
          <img class="editing-water-intake history-float-right" src="@/assets/meal_history/アセット 40@2x.png" v-show="!selected" @click="editingWaterRecords" />
        </div>
        <div>
          <img class="weekly-table history-float-right" src="@/assets/meal_history/アセット 18@2x.png" width="860" height="239" loding="lazy" @click="weeklyTable" />
        </div>
      </div>
      <div class="clear-both"></div>
      <Footer />
      <InputEditFoods v-show="isActive" @handle-hide="hideEditFoods" @handle-foods-put="foodsIngestedPutApi" @handle-foods-post="foodsIngestedPostApi" :isfirstRecord="isfirstRecord"/>
      <InputEditWater v-show="isWaterActive" @handle-hide="hideEditWater" @handle-water-put="waterIngestedPutApi" @handle-water-post="waterIngestedPostApi" :isfirstRecord="isfirstRecord"/>
    </section>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import InputEditFoods from "@/molecules/InputEditFoods";
import InputEditWater from "@/molecules/InputEditWater";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import moment from "moment";
import { VueLoading } from 'vue-loading-template';
const UserRepository = RepositoryFactory.get("user");
const FoodsRepository = RepositoryFactory.get("foods");
export default {
  name: "History",
  components: {
    Footer,
    Header,
    InputEditFoods,
    InputEditWater,
    VueLoading,
  },
  props: ['propsSelected'],
  data() {
    return {
      targetDate: moment().format("YYYY-MM-DD"),
      date: moment().format("YYYY-MM-DD"),
      today: moment().format("YYYY-MM-DD"),
      isNextDay: false,
      loading: true,
      errored: false,
      selected: true,
      isMealRecords: true,
      isWaterIntake: false,
      waterIntake: 0,
      isActive: false,
      isWaterActive: false,
      isDisplay: Boolean,
      isfirstRecord: true,
      water: "",
      numberOfDrinks: "",
      foodsIngested: [],
      targetFoodsIngested: [],
      ingestedWater: "",
      mealslist: [
        { name: "炭水化物", image: require("@/assets/meal_history/アセット 24@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "にく", image: require("@/assets/meal_history/アセット 25@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "さかな", image: require("@/assets/meal_history/アセット 26@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "たまご", image: require("@/assets/meal_history/アセット 27@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "大豆製品", image: require("@/assets/meal_history/アセット 28@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "牛乳・乳製品", image: require("@/assets/meal_history/アセット 29@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "海藻", image: require("@/assets/meal_history/アセット 32@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "やさい", image: require("@/assets/meal_history/アセット 33@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "くだもの", image: require("@/assets/meal_history/アセット 34@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "いも", image: require("@/assets/meal_history/アセット 35@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
        { name: "あぶら", image: require("@/assets/meal_history/アセット 36@2x.png"), right: "", editRight: "", ingested: false, display: "inline" },
      ],
      teaCups: [
        { id: 1, img: require("@/assets/meal_entry/アセット 19@2x.png"), editImg: require("@/assets/meal_entry/アセット 19@2x.png") },
        { id: 2, img: require("@/assets/meal_entry/アセット 20@2x.png"), editImg: require("@/assets/meal_entry/アセット 20@2x.png") },
        { id: 3, img: require("@/assets/meal_entry/アセット 21@2x.png"), editImg: require("@/assets/meal_entry/アセット 21@2x.png") },
        { id: 4, img: require("@/assets/meal_entry/アセット 22@2x.png"), editImg: require("@/assets/meal_entry/アセット 22@2x.png") },
        { id: 5, img: require("@/assets/meal_entry/アセット 23@2x.png"), editImg: require("@/assets/meal_entry/アセット 23@2x.png") },
        { id: 6, img: require("@/assets/meal_entry/アセット 24@2x.png"), editImg: require("@/assets/meal_entry/アセット 24@2x.png") },
        { id: 7, img: require("@/assets/meal_entry/アセット 25@2x.png"), editImg: require("@/assets/meal_entry/アセット 25@2x.png") },
        { id: 8, img: require("@/assets/meal_entry/アセット 26@2x.png"), editImg: require("@/assets/meal_entry/アセット 26@2x.png") },
        { id: 9, img: require("@/assets/meal_entry/アセット 27@2x.png"), editImg: require("@/assets/meal_entry/アセット 27@2x.png") },
        { id: 10, img: require("@/assets/meal_entry/アセット 28@2x.png"), editImg: require("@/assets/meal_entry/アセット 28@2x.png") },
      ],
    };
  },
  beforeDestroy() {
    document.body.className = "";
  },
  created() {
    this.RefreshTokenUpdate()
  },
  mounted() {
    document.body.className = "back-color";
    this.foodIngestedPeriod();
    this.changeSelected()
  },
  methods: {
    async RefreshTokenUpdate(){
      this.$store.state.axiosHeaders.access_token_expires_in = 1614566933; //有効期限切れトークン　検証時にコメントアウト外す
      // users.access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2NDA4NzY0MDAsInVzZXJfaWQiOiI3Nzc3In0.vzDNjvjXiM8f41xSU48-zI7VYEPXPbOpVlENvuHaWgg"
      let access_token_expires_in = new Date(this.$store.state.axiosHeaders.access_token_expires_in * 1000);
      let now = new Date();

      if (now > access_token_expires_in) {
        const UserEndpoint = "token/refresh";
        const body = {
          refresh_token: this.$store.state.axiosHeaders.refresh_token,
        };
        const config = {
          withCredentials: true,
        };
        await UserRepository.put(UserEndpoint, body, {config})
        .then(response => (this.res = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          const headers = {
            Authorization: "Bearer " + this.res.access_token,
            "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
            access_token_expires_in: this.res.access_token_expires_in,
            refresh_token: this.res.refresh_token
            }
            this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
        })
      }
    },

    //遷移元によって表示の切り替え
    changeSelected(){
      this.selected = this.propsSelected
    },

    // 前日を表示する処理
    previousDay() {
      this.targetDate = moment(this.date).add(-1, "days").format("YYYY-MM-DD");
      this.targetFoodsIngested = this.targetDayFoodsIngested(this.targetDate)
      this.checkFirstRecord()
      this.foodsAndWaterIngested(this.targetFoodsIngested)
      this.date = moment(this.date).add(-1, "days").format("YYYY-MM-DD");
      this.isNextDay = true;
    },

    // 次の日を表示する処理
    nextDay() {
      this.targetDate = moment(this.date).add(1, "days").format("YYYY-MM-DD");
      this.targetFoodsIngested = this.targetDayFoodsIngested(this.targetDate)
      this.checkFirstRecord()
      this.foodsAndWaterIngested(this.targetFoodsIngested)
      this.date = moment(this.date).add(1, "days").format("YYYY-MM-DD");
      if (this.date === this.today) this.isNextDay = false;
    },

    // 日付に該当する食事履歴を取得する
    targetDayFoodsIngested(targetDate) {
      // this.targetDate = moment(this.date).add(-1, "d").format("YYYY-MM-DD");
      const len = Object.keys(this.foodsIngested).length
      for (let i = 0; i < len; i++){
        if(this.foodsIngested[i].date === targetDate) {
          return this.foodsIngested[i]
        }
      }
      return []
    },

    // 最初の食事履歴があるかどうか判定する
    checkFirstRecord() {
      if (this.targetFoodsIngested.number_recorded === void 0) {
        this.isfirstRecord = false
        this.targetFoodsIngested.score = 0
      } else {
        this.isfirstRecord = true
      }
    },
    showWaterIntake() {
      this.selected = false;
    },
    showRecordsMain() {
      this.selected = true;
    },
    editingMealRecords() {
      this.isActive = true;
    },
    hideEditFoods() {
      this.isActive = false;
      for (const meal in this.mealslist) this.mealslist[meal].editRight = "";
      this.foodsAndWaterIngested(this.targetFoodsIngested)
    },
    editingWaterRecords() {
      this.isWaterActive = true;
      this.water = this.targetFoodsIngested.water;
    },
    hideEditWater() {
      for (let i = 0; i < 10; i++) this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
      for (let i = 0; i < this.ingestedWater; i++) this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
      this.numberOfDrinks = this.ingestedWater;
      this.isWaterActive = false;
    },
    weeklyTable() {
      if (this.selected) this.$router.push("/WeeklyTable");
      if (!this.selected) this.$router.push("/WaterWeeklyBar");
    },

    //食事記録の編集画面で○をつけたり消したりする処理
    ingestedFood(food) {
      if (this.isActive) {
        if ( this.mealslist[food].editRight === "") {
          this.mealslist[food].editRight = require("@/assets/meal_history/アセット 22@2x.png");
          this.mealslist[food].ingested = true;
          this.mealslist[food].display = "inline";
          return
        }
        if (this.mealslist[food].editRight !== "") {
          this.mealslist[food].editRight = "";
          this.mealslist[food].ingested = false;
          this.mealslist[food].display = "none";
        }
      }
    },

    //一ヶ月分の食事記録を取得する
    async foodIngestedPeriod() {
      let today = moment().format("YYYY-MM-DD");
      const lastMonth = moment(today).subtract(1, "months").format("YYYY-MM-DD");
      const foodsEndpoint = "ingested/period?from=" + lastMonth + "&to=" + today;
      await FoodsRepository.getFromTo(foodsEndpoint, this.$store.state.axiosHeaders)
        .then((response) => (this.foodsIngested = response.data))
        .catch((error) => {
          console.log(error);
          this.errored = true;
        }).finally(() => (this.loading = false));
      this.$store.commit("FETCH_ADD_MEAL_RECORD", this.foodsIngested);
      this.targetFoodsIngested = this.targetDayFoodsIngested(this.targetDate)
      if(this.targetFoodsIngested.number_recorded === void 0)this.isfirstRecord = false
      this.foodsAndWaterIngested(this.targetFoodsIngested)
    },

    // 食事履歴と水分量を摂取したかどうか確認
    foodsAndWaterIngested(targetFoodsIngested) {
      this.foodsAndWaterClean()
      for (const items in targetFoodsIngested.staple_food) {
        if (targetFoodsIngested.staple_food[items]) {
          this.mealslist[items - 1].right = require("@/assets/meal_history/アセット 22@2x.png");
          this.mealslist[items - 1].editRight = require("@/assets/meal_history/アセット 22@2x.png");
          this.mealslist[items - 1].ingested = true;
          this.mealslist[items - 1].display = "inline";
        }
      }
      for (const items in targetFoodsIngested.side_dish) {
        if (targetFoodsIngested.side_dish[items]) {
          this.mealslist[items - 1].right = require("@/assets/meal_history/アセット 22@2x.png");
          this.mealslist[items - 1].editRight = require("@/assets/meal_history/アセット 22@2x.png");
          this.mealslist[items - 1].ingested = true;
          this.mealslist[items - 1].display = "inline";
        }
      }
      this.ingestedWater = targetFoodsIngested.water / 150;
      if(isNaN(this.ingestedWater))this.ingestedWater = 0
      this.numberOfDrinks = this.ingestedWater;
      for (let i = 0; i < this.ingestedWater; i++) {
        this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
        this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
      }
    },

    // 食事履歴と水分履歴のデータを最初の状態に戻す
    foodsAndWaterClean() {
      for (const items in this.mealslist) {
        this.mealslist[items].right = "";
        this.mealslist[items].editRight = ""
        this.mealslist[items].ingested = false
        this.mealslist[items].display = "none"
      }
      for (let i = 0; i < 10; i++) {
        this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
        this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
      }
    },

    // URLで指定したdateに該当するingested_foodsテーブルの毎日の食事内容を更新する
    async foodsIngestedPutApi() {
      const foodsEndpoint = "ingested/" + this.targetFoodsIngested.date;
      const body = {
        staple_food: { 1: this.mealslist[0].ingested },
        side_dish: {},
        water: this.targetFoodsIngested.water,
        number_recorded: this.targetFoodsIngested.number_recorded + 1,
      };
      const len = this.mealslist.length;
      //副食の判定
      for (let i = 1; i < len; i++) {
        this.$set(body.side_dish, i + 1, this.mealslist[i].ingested);
      }
      await FoodsRepository.put(foodsEndpoint, body, this.$store.state.axiosHeaders)
        .then((response) => console.log(response.data))
        .catch((error) => {
          console.log(error);
          this.errored = true;
        }).finally(() => (this.loading = false));
      this.isActive = false;
      for (const items in this.mealslist) this.mealslist[items].right = "";
      this.foodIngestedPeriod();
    },

    // URLで指定したdateに該当するingested_foodsテーブルの毎日の食事内容の最初の記録を行う
    async foodsIngestedPostApi() {
      const foodsEndpoint = "ingested"
      const body = {
        staple_food: { 1: this.mealslist[0].ingested },
        side_dish: {},
        water: 0,
        number_recorded: 1,
        date: this.targetDate
      };
      const len = this.mealslist.length;
      //副食の判定
      for (let i = 1; i < len; i++) {
        this.$set(body.side_dish, i + 1, this.mealslist[i].ingested);
      }
      console.log(body)
      await FoodsRepository.post(foodsEndpoint, body, this.$store.state.axiosHeaders)
        .then((response) => console.log(response.data))
        .catch((error) => {
          console.log(error);
          this.errored = true;
        }).finally(() => (this.loading = false));
        this.isActive = false;
      for (const items in this.mealslist) this.mealslist[items].right = "";
      this.isfirstRecord = true
      this.foodIngestedPeriod();
    },

    // URLで指定したdateに該当するingested_foodsテーブルの毎日の水分摂取量を更新する
    async waterIngestedPutApi() {
      const foodsEndpoint = "ingested/" + this.targetFoodsIngested.date;
      const body = {
        staple_food: this.targetFoodsIngested.staple_food,
        side_dish: this.targetFoodsIngested.side_dish,
        water: this.water,
        number_recorded: this.targetFoodsIngested.number_recorded + 1,
      };
      await FoodsRepository.put(foodsEndpoint, body, this.$store.state.axiosHeaders)
        .then((response) => console.log(response.data))
        .catch((error) => {
          console.log(error);
          this.errored = true;
        }).finally(() => (this.loading = false));
      this.isWaterActive = false;
      for (const items in this.mealslist) this.mealslist[items].right = "";
      for (let i = 0; i < 10; i++) this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
      this.foodIngestedPeriod();
    },

    // URLで指定したdateに該当するingested_foodsテーブルの最初の水分摂取量を記録する
    async waterIngestedPostApi() {
      const foodsEndpoint = "ingested"
      const body = {
        staple_food: { 1:false },
        side_dish: { 2:false, 3:false, 4:false, 5:false, 6:false, 7:false, 8:false, 9:false, 10:false, 11:false},
        water: this.water,
        number_recorded: 1,
        date: this.targetDate
      };
      console.log(body)
      await FoodsRepository.post(foodsEndpoint, body, this.$store.state.axiosHeaders)
        .then((response) => console.log(response.data))
        .catch((error) => {
          console.log(error);
          this.errored = true;
        }).finally(() => (this.loading = false));
      this.isWaterActive = false;
      for (const items in this.mealslist) this.mealslist[items].right = "";
      for (let i = 0; i < 10; i++) this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
      this.isfirstRecord = true
      this.foodIngestedPeriod();
    },
    // 水分摂取量の編集
    pushedTeaDrink(index) {
      if (this.isWaterActive) {
        if (this.numberOfDrinks === index) {
          if (this.isDisplay) {
            for (let i = 0; i < index; i++) {
              this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
            }
            this.isDisplay = false;
            this.water = 0;
          } else {
            for (let i = 0; i < index; i++) {
              this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
            }
            this.isDisplay = true;
            this.numberOfDrinks = index;
            this.water = this.numberOfDrinks * 150;
          }
        }
        if (this.numberOfDrinks > index) {
          for (let i = 0; i < 10; i++) {
            this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
          }
        }
        if (this.numberOfDrinks !== index) {
          for (let i = 0; i < index; i++) {
            this.teaCups[i].editImg = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
            this.numberOfDrinks = index;
          }
          this.isDisplay = true;
          this.water = this.numberOfDrinks * 150;
        }
      }
    },
  },
};
</script>

<style scoped>
@import "../assets/css/history.css";
</style>


// WEBPACK FOOTER //
// src/pages/History.vue